
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "FlaggableObject": [
      "AuditAnswerImage",
      "DisplayAuditImage",
      "DisplayImage",
      "DisplaySegment",
      "DisplayTypeImage",
      "Image",
      "IndoorMap",
      "MerchandiserDisplayScanImage",
      "ModcomComplianceImage",
      "MultiProductImage",
      "PicOSDisplaySaleImage",
      "PicOSMarketingMaterialImage",
      "PicosImage",
      "PlanogramSegmentFlaggedIssueImage",
      "Product",
      "ProductImage",
      "ScanImage",
      "StoreImage",
      "TrainingImage",
      "UserImage"
    ],
    "ImageBase": [
      "AuditAnswerImage",
      "DisplayAuditImage",
      "DisplayImage",
      "DisplayTypeImage",
      "Image",
      "MerchandiserDisplayScanImage",
      "ModcomComplianceImage",
      "MultiProductImage",
      "PicOSDisplaySaleImage",
      "PicOSMarketingMaterialImage",
      "PicosImage",
      "PlanogramProductImage",
      "PlanogramSegmentFlaggedIssueImage",
      "ProductImage",
      "ScanImage",
      "StoreImage",
      "TrainingImage",
      "UserImage"
    ],
    "PointCloudBase": [
      "DisplayAuditPointCloud",
      "DisplayRestockPointCloud",
      "MerchandiserPointCloud",
      "SingleProductPointCloud",
      "SyntheticPointCloud",
      "TrainingPointCloud"
    ],
    "StoreTask": [
      "DisplayTask"
    ],
    "TaskBase": [
      "DisplayTask"
    ],
    "VideoBase": [
      "MultiProductVideo"
    ],
    "ZoneHierarchyGlobalSearchResult": [
      "CompanyStore",
      "User",
      "Zone"
    ]
  }
};
      export default result;
    